import http, { handleApiResponse, handleApiResponseWithSuccess } from '@/services/http'
import PcCode from "../models/PcCode";
import ApiResponse from '@/models/ApiResponse'

export default class PcCodeApi {

  static updatePcCode(source: PcCode): Promise<void> {
    return http.post<ApiResponse<void>>(`pc-codes/save/${source.id}`, source)
      .then(handleApiResponseWithSuccess);
  }

  static getPcCodesByType(pcCodeType: string): Promise<PcCode[]> {
    return http.get<ApiResponse<PcCode[]>>(`pc-codes/bytype/${pcCodeType}`)
      .then(handleApiResponse);
  }
  
}